import { $put } from '@js/request'

export async function cancelRequest (orderid: string): Promise<void> {
  const res = await $put('/api/xd/order/cancel', {
    orderid
  })
  return res.data
}
